import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { JobExecution, JobExecutionCreate, JobExecutionFilter } from '../data/jobExecution';

export function createJobExecutionService(client: AxiosInstance) {
  return createCrudService<JobExecution, JobExecutionCreate, JobExecutionFilter>(
    client,
    '/platform/JobExecution',
    'id',
  );
}

export type JobExecutionService = CrudService<JobExecution, JobExecutionCreate, JobExecutionFilter>;
